var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMonday = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3D57",
  d: "M7.793 51.64a7.806 7.806 0 0 1-6.606-11.944L15.23 17.271a7.804 7.804 0 0 1 13.227 8.284L14.41 47.98a7.8 7.8 0 0 1-6.618 3.66"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCB00",
  d: "M31.99 51.642a7.805 7.805 0 0 1-6.618-11.944l14.052-22.425a7.802 7.802 0 1 1 13.208 8.283L38.606 47.981a7.8 7.8 0 0 1-6.615 3.66"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#00D647",
  d: "M56.185 51.64C60.5 51.64 64 48.228 64 44.02s-3.499-7.619-7.815-7.619-7.815 3.411-7.815 7.62c0 4.207 3.499 7.619 7.815 7.619"
})));
export default SvgMonday;